export class GettyOrderDetailFilterModel {
    public userId: string;
    constructor() {
        this.userId = '';
    }
}
